'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fat';
var iconName = 'bone-break';
var width = 640;
var height = 512;
var aliases = [];
var unicode = 'f5d8';
var svgPathData = 'M328-16c0-4.4-3.6-8-8-8s-8 3.6-8 8l0 96c0 4.4 3.6 8 8 8s8-3.6 8-8l0-96zM181.7 42.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3l64 64c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3l-64-64zm288 11.3c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0l-64 64c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l64-64zM96 128c-53 0-96 43-96 96 0 24.6 9.3 47 24.4 64-15.2 17-24.4 39.4-24.4 64 0 53 43 96 96 96 47.6 0 87.1-34.6 94.7-80l258.7 0c7.6 45.4 47.1 80 94.7 80 53 0 96-43 96-96 0-24.6-9.3-47-24.4-64 15.2-17 24.4-39.4 24.4-64 0-53-43-96-96-96-47.6 0-87 34.6-94.7 80L400 208c-2.9 0-5.6 1.6-7 4.1l-73 131.4-73-131.4c-1.4-2.5-4.1-4.1-7-4.1l-49.3 0c-7.6-45.4-47.1-80-94.7-80zm87.6 96l51.7 0 71.1 128-122.8 0c-4.1 0-7.6 3.2-8 7.3-3.7 40.8-37.9 72.7-79.7 72.7-44.2 0-80-35.8-80-80 0-22.9 9.6-43.6 25.1-58.2 1.6-1.5 2.5-3.6 2.5-5.8s-.9-4.3-2.5-5.8c-15.5-14.6-25.1-35.3-25.1-58.2 0-44.2 35.8-80 80-80 41.7 0 76 32 79.7 72.7 .4 4.1 3.8 7.3 8 7.3zm272.7 0c4.1 0 7.6-3.2 8-7.3 3.7-40.8 37.9-72.7 79.7-72.7 44.2 0 80 35.8 80 80 0 22.9-9.6 43.6-25.1 58.2-1.6 1.5-2.5 3.6-2.5 5.8s.9 4.3 2.5 5.8c15.5 14.6 25.1 35.3 25.1 58.2 0 44.2-35.8 80-80 80-41.7 0-76-32-79.7-72.7-.4-4.1-3.8-7.3-8-7.3l-122.8 0 71.1-128 51.7 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBoneBreak = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;